import {mediaModuleRowSx} from "../../../components/composition/CompositionMediaView";
import {catalogItemMediaStackMq, catalogItemModuleRowStackMq} from "../../../utils/compositionMediaUtils";

export const personalizationFieldsCompactMq = "@media (max-width: 600px)";
export const personalizationFieldsNarrowMediaQuery = "(max-width: 460px)";
export const personalizationFieldsNarrowMq = `@media ${personalizationFieldsNarrowMediaQuery}`;

export const LEFT_LABEL_WIDTH = "150px";
export const RIGHT_LABEL_WIDTH = "180px";
const UNIFIED_LABEL_WIDTH = RIGHT_LABEL_WIDTH;

const personalizationFieldLabelStackedSx = {
    width: UNIFIED_LABEL_WIDTH,
    minWidth: UNIFIED_LABEL_WIDTH,
    maxWidth: UNIFIED_LABEL_WIDTH,
    alignSelf: "flex-start",
};

const personalizationFieldLabelCompactSx = {
    width: "33.333%",
    minWidth: "100px",
    maxWidth: "33.333%",
    flex: "0 1 33.333%",
    flexShrink: 1,
    alignSelf: "flex-start",
    whiteSpace: "normal",
    overflowWrap: "anywhere",
    wordBreak: "break-word",
};

export const personalizationFieldLabelSx = {
    flex: "0 0 auto",
    flexShrink: 0,
    alignSelf: "center",
    pr: "8px",
    boxSizing: "border-box",
    fontSize: "16px",
    fontWeight: 600,
    lineHeight: 1.2,
    color: (theme) => theme.palette.text.main,
    fontFamily: (theme) => theme.typography.fontFamily,
    whiteSpace: "normal",
    overflowWrap: "anywhere",
    wordBreak: "break-word",
    [catalogItemMediaStackMq]: {
        fontSize: "14px",
        pr: "6px",
    },
    [catalogItemModuleRowStackMq]: personalizationFieldLabelStackedSx,
    [personalizationFieldsCompactMq]: personalizationFieldLabelCompactSx,
};

export const personalizationFieldLabelLeftSx = {
    ...personalizationFieldLabelSx,
    width: LEFT_LABEL_WIDTH,
    minWidth: LEFT_LABEL_WIDTH,
    maxWidth: LEFT_LABEL_WIDTH,
    [catalogItemModuleRowStackMq]: personalizationFieldLabelStackedSx,
    [personalizationFieldsCompactMq]: personalizationFieldLabelCompactSx,
};

export const personalizationFieldLabelRightSx = {
    ...personalizationFieldLabelSx,
    width: RIGHT_LABEL_WIDTH,
    minWidth: RIGHT_LABEL_WIDTH,
    maxWidth: RIGHT_LABEL_WIDTH,
    [catalogItemModuleRowStackMq]: personalizationFieldLabelStackedSx,
    [personalizationFieldsCompactMq]: personalizationFieldLabelCompactSx,
};

export const personalizationFieldRowSx = {
    ...mediaModuleRowSx,
    maxWidth: "none",
    alignItems: "center",
    [catalogItemModuleRowStackMq]: {
        alignItems: "flex-start",
        minHeight: "min-content",
        height: "auto",
    },
    [personalizationFieldsCompactMq]: {
        alignItems: "flex-start",
    },
};

const personalizationFieldInputRootBaseSx = {
    backgroundColor: "#F5F6FA",
    borderRadius: 0,
    padding: 0,
    fontSize: "16px",
    fontFamily: (theme) => theme.typography.fontFamily,
    color: (theme) => theme.palette.text.main,
    [catalogItemMediaStackMq]: {
        fontSize: "14px",
    },
    "& fieldset": {border: "none"},
    "&:hover fieldset": {border: "none"},
    "&.Mui-focused fieldset": {border: "none"},
};

export const personalizationFieldInputRootSx = {
    ...personalizationFieldInputRootBaseSx,
    height: "100%",
    alignItems: "center",
};

export const personalizationMultilineInputRootSx = {
    ...personalizationFieldInputRootBaseSx,
    height: "auto",
    alignItems: "center",
};

export const personalizationFieldInputTextSx = {
    fontSize: "16px",
    fontWeight: 400,
    lineHeight: 1.2,
    color: "#2C3038",
    boxSizing: "border-box",
    py: 0,
    pl: "2px",
    pr: "2px",
    whiteSpace: "pre-wrap",
    overflowWrap: "anywhere",
    wordBreak: "break-word",
    [catalogItemMediaStackMq]: {
        fontSize: "14px",
        pl: "1px",
        pr: "1px",
    },
};

export const personalizationReadOnlyValueSx = {
    flex: "1 1 0",
    minWidth: 0,
    width: "100%",
    maxWidth: "100%",
    alignSelf: "center",
    display: "flex",
    alignItems: "center",
    backgroundColor: "#F5F6FA",
    boxSizing: "border-box",
    py: 0,
    px: "2px",
    [catalogItemModuleRowStackMq]: {
        flex: "1 1 0",
        width: "100%",
        maxWidth: "100%",
    },
    [personalizationFieldsCompactMq]: {
        flex: "1 1 66.667%",
        maxWidth: "66.667%",
        alignSelf: "flex-start",
    },
};

export const personalizationReadOnlyValueTextSx = {
    ...personalizationFieldInputTextSx,
    width: "100%",
    opacity: 0.72,
};

const personalizationPlaceholderTextSx = {
    ...personalizationFieldInputTextSx,
    opacity: 0.72,
};

export const personalizationTextFieldSx = {
    flex: "1 1 0",
    minWidth: 0,
    width: "100%",
    maxWidth: "100%",
    alignSelf: "center",
    margin: 0,
    "& .MuiOutlinedInput-root": personalizationMultilineInputRootSx,
    "& .MuiInputBase-input::placeholder": personalizationPlaceholderTextSx,
    "& .MuiInputBase-inputMultiline::placeholder": personalizationPlaceholderTextSx,
    "& .MuiInputBase-inputMultiline": {
        ...personalizationFieldInputTextSx,
        padding: "0 !important",
        minHeight: "1.2em",
        overflow: "hidden",
    },
    "& .MuiInputBase-input.Mui-disabled": {
        WebkitTextFillColor: "#2C3038",
        color: "#2C3038",
        opacity: 0.72,
    },
    [catalogItemModuleRowStackMq]: {
        flex: "1 1 0",
        width: "100%",
        maxWidth: "100%",
    },
    [personalizationFieldsCompactMq]: {
        flex: "1 1 66.667%",
        maxWidth: "66.667%",
        alignSelf: "flex-start",
    },
};

const personalizationPassportFieldBaseSx = {
    alignSelf: "center",
    margin: 0,
    width: "100%",
    maxWidth: "100%",
    minWidth: 0,
    "& .MuiFormControl-root": {
        width: "100%",
        minWidth: 0,
    },
    "& .MuiOutlinedInput-root": {
        ...personalizationMultilineInputRootSx,
        minWidth: 0,
    },
    "& .MuiInputBase-input::placeholder": personalizationPlaceholderTextSx,
    "& .MuiInputBase-inputMultiline::placeholder": personalizationPlaceholderTextSx,
    "& .MuiInputBase-inputMultiline": {
        ...personalizationFieldInputTextSx,
        padding: "0 !important",
        minHeight: "1.2em",
        overflow: "hidden",
    },
    "& .MuiInputBase-input.Mui-disabled": {
        WebkitTextFillColor: "#2C3038",
        color: "#2C3038",
        opacity: 0.72,
    },
};

export const personalizationPassportRowSx = {
    ...personalizationFieldRowSx,
    minWidth: 0,
};

export const personalizationPassportValueRowSx = {
    display: "flex",
    alignItems: "center",
    gap: "8px",
    flex: "1 1 0",
    minWidth: 0,
    width: "100%",
    maxWidth: "100%",
    alignSelf: "center",
    overflow: "hidden",
    [catalogItemModuleRowStackMq]: {
        flex: "1 1 0",
        width: "100%",
        maxWidth: "100%",
    },
    [personalizationFieldsCompactMq]: {
        flex: "1 1 0",
        maxWidth: "100%",
        alignSelf: "flex-start",
    },
};

export const personalizationPassportSeriesWrapSx = {
    flex: "1 1 0",
    minWidth: "56px",
    overflow: "hidden",
    display: "flex",
    alignItems: "center",
};

export const personalizationPassportNumberGroupSx = {
    display: "flex",
    alignItems: "center",
    gap: "6px",
    flex: "0 0 70%",
    width: "70%",
    flexShrink: 0,
    minWidth: 0,
};

export const personalizationPassportNumberRowSx = {
    ...personalizationFieldRowSx,
    minWidth: 0,
};

export const personalizationPassportSeriesFieldSx = {
    ...personalizationPassportFieldBaseSx,
    "& .MuiOutlinedInput-root": {
        ...personalizationFieldInputRootSx,
        minWidth: 0,
    },
    "& .MuiInputBase-input": {
        ...personalizationFieldInputTextSx,
        padding: "0 !important",
        height: "1.2em",
        lineHeight: 1.2,
    },
};

export const personalizationPassportNumberFieldSx = {
    ...personalizationPassportFieldBaseSx,
    flex: "1 1 0",
    minWidth: 0,
    "& .MuiOutlinedInput-root": {
        ...personalizationFieldInputRootSx,
        minWidth: 0,
    },
    "& .MuiInputBase-input": {
        ...personalizationFieldInputTextSx,
        padding: "0 !important",
        height: "1.2em",
        lineHeight: 1.2,
    },
};

export const personalizationDatePickerWrapSx = {
    flex: "1 1 0",
    minWidth: 0,
    width: "100%",
    maxWidth: "100%",
    alignSelf: "center",
    display: "flex",
    "& > div": {
        width: "100%",
        display: "flex",
        alignItems: "center",
    },
    "& .MuiFormControl-root": {
        margin: 0,
        width: "100%",
    },
    "& .MuiInputLabel-root": {
        display: "none",
    },
    "& .MuiPickersInputBase-root, & .MuiOutlinedInput-root": {
        ...personalizationMultilineInputRootSx,
    },
    "& .MuiInputBase-input": {
        ...personalizationFieldInputTextSx,
        pr: "4px",
    },
    "& .MuiInputBase-input::placeholder": personalizationPlaceholderTextSx,
    "& .MuiInputAdornment-positionEnd": {
        marginLeft: "2px",
        marginRight: "6px",
    },
    "& .MuiIconButton-root": {
        padding: "2px",
        width: "22px",
        height: "22px",
    },
    "& .MuiSvgIcon-root": {
        fontSize: "18px",
    },
    [catalogItemModuleRowStackMq]: {
        flex: "1 1 0",
        width: "100%",
        maxWidth: "100%",
    },
    [personalizationFieldsCompactMq]: {
        flex: "1 1 66.667%",
        maxWidth: "66.667%",
        alignSelf: "flex-start",
    },
};

export const getPersonalizationFieldLabelSx = (column) =>
    column === "right" ? personalizationFieldLabelRightSx : personalizationFieldLabelLeftSx;

export const personalizationAddressSectionSx = {
    display: "flex",
    flexDirection: "column",
    gap: "8px",
    width: "100%",
    maxWidth: "100%",
    minWidth: 0,
    mt: "8px",
    [catalogItemMediaStackMq]: {
        gap: "6px",
    },
};
